import { render, staticRenderFns } from "./files-history.vue?vue&type=template&id=f09d1084&scoped=true"
import script from "./files-history.vue?vue&type=script&lang=js"
export * from "./files-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09d1084",
  null
  
)

export default component.exports